export const useUseRouteCallbackUrl = (route: string) => {
  const callbackUrl = useRoute().query.callbackUrl as string | undefined;

  if (callbackUrl) {
    return `${route}?callbackUrl=${callbackUrl}`;
  }

  return route;
};
